<template>
  <section class="section">
    <h3>Port Summary</h3>

    <div v-if="requestError"
      data-name="summary-error">
      <mega-error :custom-error="requestError" />
    </div>

    <el-tabs v-if="!isLoading && !requestError"
      v-model="resourceTab"
      data-name="summary-results"
      @tab-click="changeTab">
      <el-tab-pane label="By country"
        name="country">
        <summary-table :port-summary="countriesSummary"
          :labels="{ name: 'Country' }" />
      </el-tab-pane>
      <el-tab-pane label="APAC"
        name="APAC">
        <summary-table :port-summary="regionSummary"
          :labels="{ name: 'City' }" />
      </el-tab-pane>
      <el-tab-pane label="EU"
        name="EU">
        <summary-table :port-summary="regionSummary"
          :labels="{ name: 'City' }" />
      </el-tab-pane>
      <el-tab-pane label="NAM"
        name="NAM">
        <summary-table :port-summary="regionSummary"
          :labels="{ name: 'City' }" />
      </el-tab-pane>
    </el-tabs>
  </section>
</template>

<script>
import SummaryTable from './summary-table'
import MegaError from '@/components/mega-error/mega-error'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DashPortSummary',

  components: {
    'summary-table': SummaryTable,
    'mega-error': MegaError,
  },

  props: {
    locations: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      resourceTab: 'country',
      selectedRegion: 'APAC',
      countries: [],
      countriesSummary: [],
      isLoading: true,
      requestError: null,
    }
  },

  computed: {
    ...mapState('ecosystem', ['portSummary']),
    regionSummary() {
      return this.portSummary[this.selectedRegion].cities.map(city => {
        const summaryData = this.portSummary[city] || {}
        return {
          name: city,
          total: summaryData.total || 0,
          new: summaryData.NEW || 0,
          deployable: summaryData.DEPLOYABLE || 0,
          configured: summaryData.CONFIGURED || 0,
          live: summaryData.LIVE || 0,
        }
      })
    },
  },

  created() {
    this.generateCountryList()
  },

  beforeMount() {
    this.loadData()
  },

  methods: {
    ...mapActions('ecosystem', ['getPortSummary']),
    async loadData() {
      try {
        await this.getPortSummary()
      } catch (error) {
        this.$bvToast.toast(`[${error.status} ${error.statusText}] There was an issue loading this resource. `, {
          title: 'Failed to load',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-right',
        })
      }

      this.generateCountrySummary()
      this.isLoading = false
    },
    changeTab(tab) {
      this.resourceTab = tab.name
      if (this.resourceTab !== 'country') this.selectedRegion = tab.name
    },
    generateCountryList() {
      const locationsList = new Set()
      this.locations.forEach(loc => {
        locationsList.add(loc.country)
      })
      this.countries = Array.from(locationsList).sort()
    },
    generateCountrySummary() {
      this.countriesSummary = this.countries.map(country => {
        const summaryData = this.portSummary[country] || {}
        return {
          name: country,
          total: summaryData.total || 0,
          new: summaryData.NEW || 0,
          deployable: summaryData.DEPLOYABLE || 0,
          configured: summaryData.CONFIGURED || 0,
          live: summaryData.LIVE || 0,
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
h3 {
  font-size: 1rem;
}
</style>
